import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'diretrizes-estado',
    templateUrl: './diretrizes-estado.component.html',
    styleUrls: ['./diretrizes-estado.component.css']
})
export class DiretrizesEstadoComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
